import { HorizontalProductCardBody } from "./HorizontalProductCardBody";
import { HorizontalProductCardBrandName } from "./HorizontalProductCardBrandName";
import { HorizontalProductCardButton } from "./HorizontalProductCardButton";
import { HorizontalProductCardColorSwatch } from "./HorizontalProductCardColorSwatch";
import { HorizontalProductCardFooter } from "./HorizontalProductCardFooter";
import { HorizontalProductCardHeader } from "./HorizontalProductCardHeader";
import { HorizontalProductCardImage } from "./HorizontalProductCardImage";
import { HorizontalProductCardInlineStack } from "./HorizontalProductCardInlineStack";
import { HorizontalProductCardPricing } from "./HorizontalProductCardPricing";
import { HorizontalProductCardProductName } from "./HorizontalProductCardProductName";
import { HorizontalProductCardRating } from "./HorizontalProductCardRating";
import { HorizontalProductCardRoot } from "./HorizontalProductCardRoot";
import { HorizontalProductCardVariationName } from "./HorizontalProductCardVariationName";
import { HorizontalProductCardWishlist } from "./HorizontalProductCardWishlist";

export const HorizontalProductCard =
  HorizontalProductCardRoot as typeof HorizontalProductCardRoot & {
    ColorSwatch: typeof HorizontalProductCardColorSwatch;
    Header: typeof HorizontalProductCardHeader;
    Image: typeof HorizontalProductCardImage;
    Wishlist: typeof HorizontalProductCardWishlist;
    Button: typeof HorizontalProductCardButton;
    Footer: typeof HorizontalProductCardFooter;
    Rating: typeof HorizontalProductCardRating;
    BrandName: typeof HorizontalProductCardBrandName;
    VariationName: typeof HorizontalProductCardVariationName;
    ProductName: typeof HorizontalProductCardProductName;
    Pricing: typeof HorizontalProductCardPricing;
    Body: typeof HorizontalProductCardBody;
    InlineStack: typeof HorizontalProductCardInlineStack;
  };

HorizontalProductCard.ColorSwatch = HorizontalProductCardColorSwatch;
HorizontalProductCard.Header = HorizontalProductCardHeader;
HorizontalProductCard.Image = HorizontalProductCardImage;
HorizontalProductCard.Wishlist = HorizontalProductCardWishlist;
HorizontalProductCard.Button = HorizontalProductCardButton;
HorizontalProductCard.Footer = HorizontalProductCardFooter;
HorizontalProductCard.Rating = HorizontalProductCardRating;
HorizontalProductCard.BrandName = HorizontalProductCardBrandName;
HorizontalProductCard.VariationName = HorizontalProductCardVariationName;
HorizontalProductCard.ProductName = HorizontalProductCardProductName;
HorizontalProductCard.Pricing = HorizontalProductCardPricing;
HorizontalProductCard.Body = HorizontalProductCardBody;
HorizontalProductCard.InlineStack = HorizontalProductCardInlineStack;

export type { ProductCardDataType } from "./types";
